import {
    ADD_FAVOURITE_EMP_SUCCESS,
    FETCH_ALL_EMP_SUCCESS,
    FETCH_EMP_SURVEY_ANSWERS_SUCCESS,
    FILTER_EMP,
    GET_ALL_EMP,
    GET_UNSELECTED_ALL_EMP,
    HANDLE_EMP_REQUEST_CLOSE,
    HIDE_EMP_LOADER,
    SHOW_EMP_LOADER,
    ON_ADD_EMP,
    ON_ALL_EMP_SELECT,
    ON_EMP_CLOSE,
    ON_EMP_SELECT,
    ON_DELETE_EMP,
    ON_DELETE_SELECTED_EMP,
    ON_FILTER_EMP_OPTION_SELECT,
    ON_SAVE_EMP_SUCCESS,
    ON_TOGGLE_EMP_DRAWER,
    SHOW_EMP_MESSAGE,
    UPDATE_SEARCH_EMP,
    FETCH_NOTIFICATIONS_SUCCESS,
    HIDE_EMP_DASHBOARD_LOADER,
    SHOW_EMP_DASHBOARD_LOADER,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No employees found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: 'All employees',
    allEmp: [],
    empList: [],
    selectedEmp: null,
    selectedEmps: 0,
    addEmpState: false,
    searchEmp: '',
    empSurveyAnswers: {},
    notifications: [],
    loadingDashboard: false,
    emp: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'assets/images/organisation-150_150.jpg'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_NOTIFICATIONS_SUCCESS: {
            return {
                ...state,
                notifications: action.payload,
            };
        }
        case ADD_FAVOURITE_EMP_SUCCESS: {
            const allEmpUpdated = state.allEmp.map((emp) => emp ?.id === action ?.payload ?.id ? {
                ...emp,
                starred: !action ?.payload ?.starred
            } : emp);
            let empListUpdated = {};
            switch (state.filterOption) {
                case 'All employees': {
                    empListUpdated = allEmpUpdated;
                    break;
                }
                case 'Starred employees': {
                    empListUpdated = allEmpUpdated.filter((emp) => emp.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? 'Employee removed as star' : 'Employee marked as star',
                showMessage: true,
                empList: empListUpdated,
                allEmp: allEmpUpdated
            };
        }
        case FETCH_ALL_EMP_SUCCESS: {
            return {
                ...state,
                loader: false,
                allEmp: action.payload,
                empList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: 'All employees',
            };
        }
        case FETCH_EMP_SURVEY_ANSWERS_SUCCESS: {
            return {
                ...state,
                loader: false,
                empSurveyAnswers: action.payload,
            };
        }
        case SHOW_EMP_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_EMP_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedEmps = 0;
            const empList = state.empList.map(emp => {
                if (emp.selected) {
                    selectedEmps++;
                }
                if (emp.id === action.payload.id) {
                    if (emp.selected) {
                        selectedEmps++;
                    }
                    return action.payload;
                } else {
                    return emp;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedEmps: selectedEmps,
                empList: empList
            };
        }
        case ON_ADD_EMP: {
            return { ...state, addEmpState: true };
        }
        case ON_EMP_CLOSE: {
            return { ...state, addEmpState: false };
        }
        case ON_FILTER_EMP_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let empList = [];
            switch (action.payload.name) {
                case 'All employees': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    empList = state.allEmp;
                    break;
                }
                case 'Starred employees': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    empList = state.allEmp.filter((emp) => emp.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, empList, drawerState: false
            };
        }
        case ON_SAVE_EMP_SUCCESS: {
            return {
                ...state,
                alertMessage: 'Employee Updated Successfully',
                showMessage: true,
                empList: addOrUpdateEntry(state.empList, action.payload),
                allEmp: addOrUpdateEntry(state.allEmp, action.payload),
                loader: false,
            };
        }
        case ON_DELETE_EMP: {
            return {
                ...state,
                alertMessage: 'Employee Deleted Successfully',
                showMessage: true,
                allEmp: state.allEmp.filter((emp) => emp.id !== action.payload.id),
                empList: state.allEmp.filter((emp) => emp.id !== action.payload.id),
            };
        }
        case ON_DELETE_SELECTED_EMP: {
            const emps = state.allEmp.filter((emp) => !emp.selected);
            return {
                ...state,
                alertMessage: 'Employee Filtered Successfully',
                showMessage: true,
                allEmp: emps,
                empList: emps,
                selectedEmps: 0
            };
        }
        case FILTER_EMP: {
            const { filterOption } = state;
            let empList = [];
            if (action.payload === '') {
                empList = state.allEmp;
            } else {
                const filterEmployee = state.allEmp.filter((emp) =>
                    emp.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === 'All emps') {
                    empList = filterEmployee;
                } else if (filterOption === 'Frequently accessed') {
                    empList = filterEmployee.filter((emp) => emp.frequently);
                } else if (filterOption === 'Starred employees') {
                    empList = filterEmployee.filter((emp) => emp.starred);
                }
            }
            return { ...state, empList: empList };
        }
        case GET_ALL_EMP: {
            let empList = state.allEmp.map((emp) => emp ? {
                ...emp,
                selected: true
            } : emp);
            return {
                ...state,
                selectedEmps: empList.length,
                allEmp: empList,
                empList: empList
            };
        }
        case GET_UNSELECTED_ALL_EMP: {
            let empList = state.allEmp.map((emp) => emp ? {
                ...emp,
                selected: false
            } : emp);
            return {
                ...state,
                selectedEmps: 0,
                allEmp: empList,
                empList: empList
            };
        }
        case ON_ALL_EMP_SELECT: {
            const selectAll = state.selectedEmps < state.empList.length;
            let selectedEmps = 0;
            let empList = [];
            if (selectAll) {
                empList = state.allEmp.map((emp) => emp ? {
                    ...emp,
                    selected: true
                } : emp);
                selectedEmps = empList.length;
            } else {
                empList = state.allEmp.map((emp) => emp ? {
                    ...emp,
                    selected: true
                } : emp);
                selectedEmps = 0;
            }
            return {
                ...state,
                selectedEmps: selectedEmps,
                allEmp: empList,
                empList: empList
            };
        }
        case UPDATE_SEARCH_EMP: {
            return { ...state, searchEmp: action.payload };
        }
        case HANDLE_EMP_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_EMP_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_EMP_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_EMP_LOADER: {
            return { ...state, loader: false };
        }
        case SHOW_EMP_DASHBOARD_LOADER: {
            return { ...state, loadingDashboard: true };
        }
        case HIDE_EMP_DASHBOARD_LOADER: {
            return { ...state, loadingDashboard: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/Employee.js